import { ACTIONS } from 'actions/control-chat-positioning';

const initialState = {
  element: null,
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.SET_CHATBOX_POSITION: {
      return { ...state, element: payload };
    }

    default:
      return state;
  }
}
